import React from 'react';

const TableBackdrop = (props) => (
    <div className="tablebackdrop" onClick={props.click}/>
);

export default TableBackdrop;